<div class="d-flex row-cols-12">
    <div class="col-12">
    <h3 class="title float-start" translate>Settings.General</h3>
    </div>
</div>
<div class="px-4 my-2 mb-1 d-table col-12">
    <span class="pt-5 pb-2 col-12" translate="Settings.SecuritySection.General.Options"></span>
    <ul class="mb-3 mt-2 list-group">
        
        <li class="list-group-item d-block" *ngIf="(user.organisationGuid === selectedOrganisationId) && user.isOrganisationAdmin">
            <div class="row row-cols-12 d-flex align-items-center">
                <div class="d-table form-check form-switch">
                    <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="showAllInOrg" name="showAllInOrg" (click)="updateAllDocsInOrg()" [checked]="showAllDocsInOrg">
                    <label translate="Settings.SecuritySection.General.ShowAllInOrg" for="showAllInOrg"><app-info-button labelName="Settings.SecuritySection.General.ShowAllInOrgTooltip" placement="bottom"></app-info-button></label>
                </div>
            </div>
        </li>
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Two_Factor_Authentication">
            <li class="list-group-item d-block">
            <div class="row row-cols-12 d-flex align-items-center">
                <div class="d-table form-check form-switch">
                    <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="forceTwoFactor" name="forceTwoFactor" (click)="updateTwoFactor($event)" 
                    [checked]="twoFactorRequired?.twoFactorRequired"  [disabledByPermission]="permissionEnum.Perm_Two_Factor_Authentication">
                    <label translate="Settings.SecuritySection.General.ForceTwoFactor" for="forceTwoFactor"><app-info-button labelName="Settings.SecuritySection.General.ForceTwoFactorTooltip"></app-info-button></label>
                </div>
            </div>
        </li>
    </app-hide-by-permission-wrapper>

    </ul>
</div>